import { QueryFn } from '@percent/grants-nomination-form/hooks/useQuery/useQuery.types';
import { GetCountriesResponse } from './countries.types';
import { config } from '@percent/grants-nomination-form/config/config';

export const getCountriesAction: QueryFn<[string], GetCountriesResponse> = async (client, [_]) => {
  const response = await client.get(`v1/countries`, { headers: { Authorization: config.keys.pk } });

  return response.data;
};
